import { SdkStoreConfig } from '@gamiphy/loyalty-station-desktop/store/sdk/types';
import { AppDtoAgentEnum } from '@coretava/api/core-service';

/**
 * @deprecated
 */
export const getLegacyGoToAuth = (agent?: AppDtoAgentEnum): SdkStoreConfig['goToAuth'] | undefined => {
  switch (agent) {
    case 'magento':
      return (isSignUp) => {
        const url = new URL(
          isSignUp
            ? `${window.location.origin}/customer/account/create`
            : `${window.location.origin}/customer/account/login`,
        );

        window.location.href = url.toString();
      };
    case 'prestashop':
      return (isSignUp) => {
        const url = new URL(
          isSignUp
            ? `${window.location.origin}/login?create_account=1`
            : `${window.location.origin}/login`,
        );

        window.location.href = url.toString();
      };
    case 'shopify':
      return (isSignUp) => {
        const url = new URL(
          isSignUp
            ? `${window.location.origin}/account/register`
            : `${window.location.origin}/account/login`,
        );

        window.location.href = url.toString();
      };
    case 'vtex':
      return () => {
        const url = new URL(`${window.location.origin}/login`);
        url.searchParams.set('returnUrl', window?.location.href);

        window.location.href = url.toString();
      };
    default:
    // do-nothing
  }
  return undefined;
};
